import { Box } from '@material-ui/core';
import { formatMoney } from '@nemuru-eng/js-api-client';

import { ContrastedCard } from '@/components/shared/components/ContrastedCard';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

export const StepCard = ({ stepStats, isSelected, currency, onClick, isMilestone = false }) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const { sm } = useScreen();
  return (
    <>
      <ContrastedCard
        onClick={onClick}
        boxProps={{
          style: {
            padding: '6px 12px',
            minHeight: '44px',
          },
        }}
        paperProps={{
          style: {
            boxShadow: 'none',
            marginBottom: sm ? '6px' : '16px',
            backgroundColor: isSelected ? palette.secondary.main : palette.grey[50],
            borderRadius: customBorderRadius.paper,
          },
        }}
      >
        <Box flex={1}>
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            width={'100%'}
            alignItems={'center'}
            color={
              isSelected ? palette.secondary.contrastText : isMilestone ? palette.text.primary : palette.text.secondary
            }
          >
            <Font
              variant={'subtitle2'}
              align={'left'}
              style={{ width: !sm ? '85px' : '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              <Text
                tId={isMilestone ? stepStats.step.associatedMilestone : stepStats.step.tId}
                strong={stepStats.step.milestone}
              />
            </Font>
            <Font variant={'subtitle2'}>
              <Box
                display={'flex'}
                minWidth={'155px'}
                justifyContent={'space-between'}
                style={{ opacity: stepStats.loans.length ? 1 : 0.3 }}
              >
                <Box pl={sm ? 3 : 2}>{stepStats.loans.length}</Box>
                <Box>
                  {formatMoney(
                    {
                      value: stepStats.totalAmount,
                      currency: currency,
                    },
                    0,
                  )}
                </Box>
              </Box>
            </Font>
          </Box>
        </Box>
      </ContrastedCard>
    </>
  );
};
